import React from 'react';
export var LabelEdge = function (props) {
    var _a = props.data, data = _a === void 0 ? {} : _a;
    var label = data.label, fontFill = data.fontFill, fontSize = data.fontSize;
    return (React.createElement("div", { style: {
            textAlign: 'center',
        } },
        React.createElement("span", { style: {
                fontSize: fontSize,
                color: fontFill,
            } }, label)));
};
